import { defaultVehicle } from '../../../types';
import { saveApplication, debounce } from './../../../utilities';
import { DEBOUNCE_TIME } from './../../../constants';
import validate from '../../../validations';


export default {
    refreshOn: ({ vehicles, haveVehicle }) => [ vehicles, haveVehicle ],
    init: (fullState, stateManager, internalStateSetter) => {
        debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)
    },
    'Vehicles.Wrapper.NoVehicles': ({ haveVehicle, checked }, stateManager) => {
        stateManager.set({ haveVehicle: false, vehicles: [] })
    },
    'Vehicles.Wrapper.HaveVehicles': ({ haveVehicle, checked }, stateManager) => {
        const newVehicle = {...defaultVehicle}
        stateManager.set({ haveVehicle: true, vehicles: [newVehicle] })
    },
    'Vehicles.Wrapper.VehiclesList': ({ vehicles }, stateManager) => {
        stateManager.setVehicles(vehicles)
        validate(3000);
    },
    'Vehicles.Wrapper.AddVehicle': ({ vehicles }, stateManager) => {
        const newVehicle = {...defaultVehicle}
        stateManager.setVehicles([...vehicles, newVehicle])
    },
};
